export default __webpack_public_path__ + "static/media/2.6d17dd82.jpg";